import { Navigate, Outlet } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useAuth } from "../context/AuthContext";

const AuthGuard = () => {
  const { accounts, inProgress } = useMsal();
  const { token } = useAuth();
    
  if (inProgress === "startup") {
    return <div>Loading...</div>;
  }

  // Must have MSAL login + backend token
  if (!accounts?.length || !token) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default AuthGuard;
